import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { QuestRoute } from '../../api/QuestRoutes';
import { formatCurrency, exportToPDF, generateId, shortHandDateTime, translate } from '../../utility/functions';
import Page from '../../layout/Page';
import Table from '../../table/Table';
import { useParams } from 'react-router-dom';
import Button from '../../forms/Button';
import HamQuest from '../../api/HamQuestGiver';
import Card from '../../forms/Card';
import Col from '../../layout/Col';
import Title from '../../forms/Title';
import Loading from '../../Loading';
import Row from '../../layout/Row';
import ModalFactory from '../../Modal';
import { SCREEN_MAX_WIDTH, SCREEN_WIDTH } from '../../../constants/config';
import Input from '../../forms/Input';
import RequiredFeature, { Features } from '../../RequireFeature';

const HeaderRow = styled(Row)`
    display: flex;
    gap: 4em;
    justify-content: space-between;
    align-items: flex-start;
`
const ReportSegment = styled.div`
    border-bottom: 1px solid ${({ theme }) => theme.gray}40;
    margin-bottom: 0.5em;
    padding-bottom: 0.2em;
`
const CardWrap = styled(Card)`
    margin: 0.5em;
    min-width: 50em;

    @media (max-width: ${SCREEN_MAX_WIDTH}) {
        min-width: unset;
        width: 70svw;
    }
`

const SearchUser = (name, email, setUserData) => {
    HamQuest.post(QuestRoute.user.search, {Email: email, UserName: name})
        .then((res) => {
            if(res != null) {   
                setUserData(prev => ({
                    ...prev,
                    accountName: res.userName,
                    loyaltyAccountId: res.loyaltyAccountId,
                    email: res.email
                }));
            }else{
                setUserData(prev => ({
                    ...prev,
                    accountName: undefined,
                    loyaltyAccountId: undefined,
                    email: email
                }));
            }
        })
        .catch(ModalFactory.catch);
}

const IssueRefund = (data, reason, setData, refundModalId) => {
    var postData = {transactionId: data.recordId, loyaltyAccountId: data.loyaltyAccountId, reason: reason};  
    HamQuest.post(QuestRoute.reports.refundTransaction, postData)
        .then((res) => {
            ModalFactory.close(refundModalId);
            setData(prev => ({
                ...prev,      
                refunded: true,
            }));
            const successModalId = generateId();
            ModalFactory.show({
                id: successModalId,
                title: 'Success!',
                body: (<p>Refund Issued.</p>),
                type: 'success',
                hideClose: true,
                buttons: [
                    <Button
                        key='ok'
                        onClick={() => ModalFactory.close(successModalId)}
                        label='OK'
                        autoFocus
                    />
                ]
            });
        })
        .catch(ModalFactory.catch);
}

const RefundModal = (data, setData) => {
    const refundModalId = generateId();

    const UserSearch = ({ ...props }) => {
        const [tempEmail, setTempEmail] = useState(data.userEmail || "");
        const [tempName, setTempName] = useState(data.accountName || "");
        const [reason, setReason] = useState("");
        const [userData, setUserData] = useState({ ...data, email: data.userEmail });
    return (
        <>
            <Input
                label={'User Name'}
                type='text'
                value={tempName}
                onChange={(e) => {
                    setTempName(e.target.value);
                }}
                standalone
            />
            <Row>
            <Input
                label={'User email'}
                type='text'
                value={tempEmail}
                onChange={(e) => {
                    setTempEmail(e.target.value);
                }}
                standalone
            />
                <Button style={{ marginTop: '15px' }} onClick={() => {SearchUser(tempName, tempEmail, setUserData, props.setData)}}>Search</Button>
            </Row>
            <br/>
            {(userData && userData.accountName) ?
            <>
            <Row>
                <label><b>Name:</b></label>
                <label>{userData.accountName}</label>
            </Row>
            <Row>
                <label><b>Email:</b></label>
                <label>{userData.email}</label>
            </Row> 
            </>: 
            <Row>
                <label style={{color: "red"}}><b>User Not Found</b></label>
            </Row>
            }
            <Row>
                <label><b>Refund Amount:</b></label>
                <label>{formatCurrency(userData.subTotal)}</label>
            </Row>
            <br/>
            <Input
                label={'Reason for Refund'}
                type='text'
                value={reason}
                onChange={(e) => {
                    setReason(e.target.value);
                }}
                standalone
            />
            <Button style={{ marginTop: '15px' }} 
            onClick={() => {IssueRefund(userData, reason, props.setData, refundModalId)}}
            disabled={!userData || !userData.loyaltyAccountId}  
            >Issue Refund</Button>
        </>);
    }

        ModalFactory.show({
            id: refundModalId,
            title: 'User Search',
            body: <UserSearch setData={setData}/>
        })

    }

const Transaction = ({ ...props }) => {

    const { transactionId } = useParams();
    const cardRef = useRef();
    const [data, setData] = useState(null)

    useState(() => {
        HamQuest.get(QuestRoute.reports.transaction + transactionId)
            .then(res => {
                console.log('results from api call', res);
                if (!res.transId) return;
                const itemTotal = res.totals.itemTotal || 0;
                const discountTotal = res.totals.discountTotal || 0;

                const subTotal = itemTotal - discountTotal;
                const taxTotal = res.totals.taxTotal || 0;
                const total = subTotal + taxTotal;

                const paymentTotal = res.totals.paymentTotal || 0;
                const changeTotal = res.totals.changeTotal || 0;

                setData({
                    ...res,
                    itemTotal,
                    discountTotal,
                    subTotal,
                    taxTotal,
                    total,
                    paymentTotal,
                    changeTotal,
                })
            })
            .catch(ModalFactory.catch)
    }, [])

    return (
        <Page title={`Transaction Report (${transactionId})`}>
            <Row>
            <Button
                disabled={!data}
                onClick={() => exportToPDF(cardRef, `Transaction Record (${transactionId})`)}
            >Export</Button>
            <RequiredFeature requiredFeatures={Features.AppCredit}>
            <Button
                disabled={!data || data.refunded}
                onClick={() => RefundModal(data, setData)}
            >Refund</Button>
            </RequiredFeature>
            </Row>


            {data ?
                <CardWrap title='Transaction Record' icon='clipboard'>
                    <div ref={cardRef}>
                        <ReportSegment>
                            <HeaderRow wrap>
                                <Col style={{ flex: 1 }}>
                                    <HeaderRow>
                                        <b style={{ whiteSpace: 'nowrap' }}>Kiosk Date & Time</b>
                                        <span style={{ whiteSpace: 'nowrap' }}>{shortHandDateTime(data.kioskDateTime)}</span>
                                    </HeaderRow>
                                    <HeaderRow>
                                        <b>Trans Record ID</b>
                                        <span>{data.recordId}</span>
                                    </HeaderRow>
                                    <HeaderRow>
                                        <b>Transaction Type</b>
                                        <span>{data.transactionType}</span>
                                    </HeaderRow>
                                    <HeaderRow>
                                        <b>Record Type</b>
                                        <span>{data.recordType}</span>
                                    </HeaderRow>
                                    <HeaderRow>
                                        <b>Kiosk Trans ID</b>
                                        <span>{data.transId}</span>
                                    </HeaderRow>
                                    <HeaderRow>
                                        <b>Sequence Number</b>
                                        <span>{data.sequenceNum}</span>
                                    </HeaderRow>
                                </Col>

                                <Col style={{ flex: 1 }}>
                                    <HeaderRow>
                                        <b>Model</b>
                                        <span>{data.model}</span>
                                    </HeaderRow>
                                    <HeaderRow>
                                        <b>Version</b>
                                        <span>{data.version}</span>
                                    </HeaderRow>
                                    <HeaderRow>
                                        <b>MAC Address</b>
                                        <span>{data.macAddress}</span>
                                    </HeaderRow>
                                    <HeaderRow>
                                        <b>Terminal Name</b>
                                        <span>{data.terminalName}</span>
                                    </HeaderRow>
                                    <HeaderRow>
                                        <b>Terminal ID</b>
                                        <span>{data.terminalId}</span>
                                    </HeaderRow>
                                    <HeaderRow>
                                        <b>Site ID</b>
                                        <span>{data.siteId}</span>
                                    </HeaderRow>
                                </Col>
                            </HeaderRow>
                        </ReportSegment>

                        <ReportSegment>
                            <HeaderRow>
                                <Title>Totals</Title>
                            </HeaderRow>
                            <Col style={SCREEN_WIDTH ? {} : { width: '50%' }}>
                                <ReportSegment>
                                    <Col style={{ flex: 1 }}>
                                        <HeaderRow>
                                            <b>Item Total(s)</b>
                                            <span>{formatCurrency(data.itemTotal)}</span>
                                        </HeaderRow>
                                        <HeaderRow>
                                            <b>Discount Total(s)</b>
                                            <span>{formatCurrency(data.discountTotal)}</span>
                                        </HeaderRow>
                                    </Col>
                                </ReportSegment>
                                <ReportSegment>
                                    <Col style={{ flex: 1 }}>
                                        <HeaderRow>
                                            <b>Subtotal</b>
                                            <span>{formatCurrency(data.subTotal)}</span>
                                        </HeaderRow>
                                        <HeaderRow>
                                            <b>Tax Total</b>
                                            <span>{formatCurrency(data.taxTotal)}</span>
                                        </HeaderRow>
                                    </Col>
                                </ReportSegment>
                                <Col style={{ flex: 1 }}>
                                    <HeaderRow>
                                        <b>Total</b>
                                        <span>{formatCurrency(data.total)}</span>
                                    </HeaderRow>
                                    <HeaderRow>
                                        <b>Payment Total</b>
                                        <span>{formatCurrency(data.paymentTotal)}</span>
                                    </HeaderRow>
                                    <HeaderRow>
                                        <b>Change Total</b>
                                        <span>{formatCurrency(data.changeTotal)}</span>
                                    </HeaderRow>
                                </Col>
                            </Col>
                        </ReportSegment>

                        <ReportSegment>
                            <HeaderRow>
                                <Title>Items</Title>
                            </HeaderRow>
                            <Table
                                config={{
                                    disableTableControls: true,
                                    disableHeaderSearch: true,
                                    data: data.items,
                                    colSpacing: [6, 10, 10, 10],
                                    headers: [
                                        {
                                            label: 'Qty',
                                            propKey: 'quantity',
                                            type: 'number'
                                        }, {
                                            label: 'Item ID',
                                            propKey: 'itemId',
                                        }, {
                                            label: 'SKU',
                                            propKey: 'SKU',
                                        }, {
                                            label: 'Vended',
                                            propKey: 'vended',
                                        }, {
                                            label: 'Description',
                                            propKey: 'description',
                                        }, {
                                            label: 'Item Type',
                                            propKey: 'itemType',
                                        }, {
                                            label: 'Item Price',
                                            propKey: 'itemPrice',
                                            type: 'number'
                                        },
                                    ],
                                    renderFormat: (e) => (
                                        <tr key={generateId()}>
                                            <td>{e.quantity}</td>
                                            <td>{e.itemId}</td>
                                            <td>{e.SKU || '-'}</td>
                                            <td>{e.vended || '-'}</td>
                                            <td>{e.description}</td>
                                            <td>{translate(e.itemType)}</td>
                                            <td>{formatCurrency(e.itemPrice)}</td>
                                        </tr>
                                    )
                                }}
                            />
                        </ReportSegment>

                        <ReportSegment>
                            <HeaderRow>
                                <Title>Payments</Title>
                            </HeaderRow>
                            <Table
                                config={{
                                    disableTableControls: true,
                                    disableHeaderSearch: true,
                                    data: data.payments,
                                    colSpacing: [40],
                                    headers: [
                                        {
                                            label: 'Payment Type',
                                            propKey: 'paymentType',
                                        }, {
                                            label: 'Amount',
                                            propKey: 'amount',
                                        }, {
                                            label: 'Account Number',
                                            propKey: 'accountNumber',
                                        },
                                    ],
                                    renderFormat: (e) => (
                                        <tr key={generateId()}>
                                            <td>
                                                <Col>
                                                    {e.paymentType}
                                                    {
                                                        e.paymentType === 'CreditCard' &&
                                                        e.cardPaymentResults.map(f => (
                                                            <Col key={generateId} style={{ marginLeft: '1em' }}>
                                                                <HeaderRow><b>Card Type</b><span>{f.cardType}</span></HeaderRow>
                                                                <HeaderRow><b>Auth #</b><span>{f.authNumber}</span></HeaderRow>
                                                                <HeaderRow><b>Card #</b><span>{f.maskedCardNumber}</span></HeaderRow>
                                                            </Col>
                                                        ))

                                                    }
                                                </Col>
                                            </td>
                                            <td>{formatCurrency(e.amount)}</td>
                                            <td>{e.accountNumber || '-'}</td>
                                        </tr>
                                    )
                                }}
                            />
                        </ReportSegment>
                    </div>
                </CardWrap>
                : <Loading page key='Loading' />
            }
        </Page>
    );
}

export default Transaction;